/* eslint-disable no-mixed-operators */
import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric'

export const Type = {
  OneToOne: '1-1',
  OneToMany: '1-N',
  ManyToMany: 'N-N'
}
export const AnswerStatus = {
  Empty: 'empty',
  Correct: 'correct',
  Wrong: 'wrong'
}
export const defineExerciseType = (options) => {
  const sources = options.filter((x) => !x.isTarget)
  const targets = sources
    .filter((x) => x.targets)
    .flatMap((item) => item.targets)
  const manyTargetsSources = sources.filter((x) => x.targets?.length > 1)
  const uniqueArr = targets.filter((item, index) => {
    return targets.findIndex((t) => t?.id === item?.id) === index
  })

  if (targets.length !== uniqueArr.length) {
    return Type.ManyToMany
  }
  if (manyTargetsSources.length === 0) {
    return Type.OneToOne
  }
  if (targets.length === uniqueArr.length) {
    return Type.OneToMany
  }
}
const faCheck = {
  path: 'M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z',
  width: 512,
  height: 512
}

const faTimes = {
  path: 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z',
  width: 512,
  height: 512
}
export const getCroppedImage = async (
  image_url,
  index,
  left,
  top,
  ratioX,
  ratioY,
  position,
  scale,
  option
) => {
  return new Promise(function (resolve, reject) {
    try {
      fabric.Image.fromURL(image_url, function (image) {
        const opts = {
          id: `source-${index}`,
          name: `source-${index}`,
          targets: option.targets,
          optionId: option.id,
          pageIcon: true,
          scale,
          top,
          left,
          scaleX: scale,
          scaleY: scale,
          opacity: 0.6,
          cropX: position.axisX * (ratioX ? ratioX : 1),
          cropY: position.axisY * (ratioY ? ratioY : 1),
          width: position.width * (ratioX ? ratioX : 1),
          height: position.height * (ratioY ? ratioY : 1),
          erasable: false,
          isMain: true,
          hasControls: false,
          hasBorders: false
        }
        image.set(opts)
        resolve(image)
      })
    } catch (error) {
      reject(error)
    }
  })
}

export const drawCircle = (x, y, radius, isGreen) => {
  // Circle şeklini oluşturun
  const circle = new fabric.Circle({
    left: x - radius,
    top: y - radius,
    radius,
    pageIcon: true,
    id: 'checkcircle',
    clearOnReset: true,
    fill: 'white',
    strokeWidth: 0,
    stroke: 'white',
    selectable: false,
    evented: false,
    erasable: false
  })
  const icon = isGreen ? faCheck : faTimes

  const iconShape = new fabric.Path(icon.path, {
    fill: isGreen ? 'green' : 'red',
    selectable: false
  })

  const iconWidth = radius * 1.8 // Icon genişliği, daire yarıçapının %60'ı olarak ayarlanıyor
  const iconHeight = iconWidth // Icon yüksekliği, oranı koruyacak şekilde hesaplanıyor

  iconShape.set({
    scaleX: iconWidth / icon.width,
    scaleY: iconHeight / icon.height,
    clearOnReset: true,
    left: circle.left + (circle.radius * 2 - iconWidth) / 2,
    top: circle.top + (circle.radius * 2 - iconHeight) / 2,
    id: 'checkshape',
    pageIcon: true,
    evented: false,
    selectable: false,
    erasable: false
  })

  // Circle'ı canvas'a ekleyin
  return { circle, iconShape }
}
